// One frame source for every action and the draw loop. Hosts can supply timers or a test clock.
export function createClock({ now = () => performance.now(),
  requestFrame = cb => requestAnimationFrame(cb), cancelFrame = id => cancelAnimationFrame(id) } = {}) {
  let paused = true, at = now(), offset = 0, pending = null, serial = 0;
  const callbacks = new Map();
  const timers = new Map();
  const time = () => (paused ? at : now()) - offset;
  function schedule() {
    if (paused || pending !== null || (!callbacks.size && !timers.size)) return;
    pending = requestFrame(() => {
      pending = null;
      const due = [...timers].filter(([, t]) => t.at <= time()).sort((a, b) => a[1].at - b[1].at || a[0] - b[0]);
      for (const [id, t] of due) { timers.delete(id); t.cb(); }
      const batch = [...callbacks.values()]; callbacks.clear();
      for (const cb of batch) cb(time());
      schedule();
    });
  }
  return {
    now: time,
    frame(cb) { const id = ++serial; callbacks.set(id, cb); schedule(); return id; },
    later(cb, ms) { const id = ++serial; timers.set(id, { at: time() + ms, cb }); schedule(); return id; },
    cancel(id) { callbacks.delete(id); },
    pause() { if (paused) return; at = now(); paused = true; if (pending !== null) cancelFrame(pending); pending = null; },
    resume() { if (!paused) return; offset += now() - at; paused = false; schedule(); },
    flush() { const batch = [...callbacks.values()]; callbacks.clear(); for (const cb of batch) cb(time()); },
    clear() { callbacks.clear(); timers.clear(); },
  };
}
